export const ORGANIZATION_SHOWCASE_TABS = {
  banks: 'banks',
  users: 'users',
  default: 'banks',
};
